import AppConfig from '../appConfig';
import { ZYW_LEADS_LOGOUT_REDIRECT } from 'lib/config/appConstants';

/**
 * Class used to communicate with the backend authentication system
 * This class currently uses a mock authentication system
 */
class LoginFetch {
  /**
   * Generic error handler for Fetch calls, throws an error if the Fetch call returned anythong other than a 200
   *
   * @param response
   * @returns {*}
   */
  static handleErrors(response) {
    if (response.ok) {
      localStorage.removeItem(ZYW_LEADS_LOGOUT_REDIRECT);
      return response;
    }
    console.log('ERROR: ' + response.status);
    throw Error(response.status);
  }

  /**
   * Calls the login API function, the Promise should resolve to a json.jwt string with the token
   *
   * @param email
   * @param password
   * @returns {Promise.<*>}
   */
  static login(email, password) {
    var form = new FormData();
    form.append('username', email);
    form.append('password', password);

    return fetch(AppConfig.loginUrl, {
      credentials: 'include',
      method: 'POST',
      body: form,
      cache: 'no-cache',
    })
      .then(LoginFetch.handleErrors)
      .then((response) => response.json());
  }

  /**
   * Calls the find user info function, which verifies the token is valid. The Promise should resolve to a json
   * string containing all user info, entitlements
   * @returns {Promise.<*>}
   */
  static findUserInfo() {
    return fetch(AppConfig.findUserInfoUrl, {
      credentials: 'include',
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    })
      .then(LoginFetch.handleErrors)
      .then((response) => response.json());
  }

  /**
   * Logout user
   *
   * @returns {Promise.<*>}
   */
  static logout() {
    return fetch(AppConfig.apiUrl + '/v1/auth/logout', {
      credentials: 'include',
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    }).then((response) => {
      if (!response.ok) {
        console.log(
          'ERROR, but resume next. Status: ' + response.status + ' ' + response.statusText
        );
        throw Error(response.status);
      }
      return response.json();
    });
  }

  /**
   * Calls the forgot password API function
   *
   * @param current_password
   * @param password
   * @param password_confirm
   * @returns {Promise.<*>}
   */
  static forgotPassword(lost_username, lost_password, username, email) {
    var form = new FormData();
    form.append('lost_username', lost_username);
    form.append('lost_password', lost_password);
    form.append('username', username);
    form.append('email', email);

    return fetch(AppConfig.apiUrl + '/v1/site/forgotpassword', {
      credentials: 'include',
      method: 'POST',
      body: form,
      cache: 'no-cache',
    })
      .then(LoginFetch.handleErrors)
      .then((response) => response.json());
  }

  static checkAccessToken() {
    return fetch(AppConfig.apiUrl + '/v1/auth/ping', {
      credentials: 'include',
      method: 'GET',
      cache: 'no-cache',
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (json.status && json.status !== 200) {
          throw Error(json.status);
        }
        return json;
      });
  }
}

export default LoginFetch;
